import { createContext } from "react";
import type { AppRole, AuthSession, LoginPayload } from "./types";

export type AuthContextValue = {
  session: AuthSession | null;
  isAuthenticated: boolean;
  role: AppRole | null;
  dashboardPath: string;
  login: (payload: LoginPayload) => Promise<AuthSession>;
  verifyMfa: (challengeToken: string, code: string, username: string) => Promise<AuthSession>;
  logout: () => void;
};

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
